import { Fragment } from "react";
import { OrderModifierGroupModel } from "../../models"

type Props = {
  modifierGroups: OrderModifierGroupModel[]
}

const OrderModifierGroups: React.FC<Props> = ({modifierGroups}) => {
  return (
    <>
      {modifierGroups
        .filter(item => item.g_parent_id === "0")
        .map((modifierGroup, modifierGroupIndex) => (
          <div key={modifierGroupIndex} className="mb-1">
            <span className="d-block">
              <strong>{modifierGroup.g_name}</strong>
            </span>
            {modifierGroup.modifiers.map((modifier, modifierIndex) => { 
              const nestedModifierGroup = modifierGroups.find(nestedItem => nestedItem.g_parent_id == modifier.m_id);
              return (
                <Fragment key={modifierIndex}>
                  <span className="d-block">{modifier.m_name}</span>
                  {nestedModifierGroup && (
                    <span className="ps-4 d-block">
                      <span className="d-block"><strong>{nestedModifierGroup.g_name}</strong></span>
                      <span className="d-block">{nestedModifierGroup?.modifiers.map(nestedItem => nestedItem.m_name).join(', ')}</span>
                    </span>
                  )}
                </Fragment>
              )
            })}
          </div>
        ))
      }
    </>
  )
}

export default OrderModifierGroups